// Comprehensive interests list with categories (matching OnboardingWizard)
const interestsData = {
  '🏃 Physical & Sports': [
    'Running', 'Gym & Weightlifting', 'Yoga', 'Pilates', 'Swimming', 'Cycling',
    'Hiking', 'Rock Climbing', 'Surfing', 'Martial Arts', 'Boxing', 'Tennis',
    'Golf', 'Basketball', 'AFL', 'Soccer', 'Cricket', 'Rugby', 'Volleyball',
    'Skateboarding', 'Dancing', 'Sailing', 'Fishing', 'Scuba Diving', 'Kayaking',
    'Horse Riding', 'Parkour', 'Archery', 'Badminton', 'Table Tennis',
    'Ice Skating', 'Triathlon', 'Pickleball'
  ],
  '🎵 Music': [
    'Live Music', 'Concerts', 'Festivals', 'DJing', 'Singing & Karaoke', 'Guitar',
    'Piano & Keyboards', 'Drums', 'Music Production', 'Classical Music', 'Jazz',
    'Hip Hop', 'Electronic', 'Rock', 'Indie', 'Country', 'R&B & Soul', 'Metal',
    'Reggae', 'Latin Music', 'K-Pop', 'Choir & A Cappella', 'Vinyl & Record Collecting',
    'Folk & Acoustic'
  ],
  '🍳 Food & Drink': [
    'Cooking', 'Baking', 'BBQ & Grilling', 'Wine Tasting', 'Craft Beer', 'Cocktails',
    'Coffee Culture', 'Foodie & Restaurant Exploring', 'Vegan & Plant-Based',
    'Meal Prep', 'Fermentation', 'Farmers Markets', 'Food Trucks', 'Tea',
    'Chocolate', 'Cheese', 'Sushi', 'Street Food', 'Brunch Culture'
  ],
  '🎨 Arts & Creative': [
    'Painting', 'Drawing', 'Photography', 'Pottery & Ceramics', 'Sculpture',
    'Printmaking', 'Digital Art', 'Graphic Design', 'Calligraphy',
    'Jewellery Making', 'Knitting & Crochet', 'Sewing', 'Woodworking',
    'Leathercraft', 'Candle Making', 'Flower Arranging', 'Tattoo Art',
    'Graffiti & Street Art', 'Film Making', 'Animation', 'Theatre & Performing Arts'
  ],
  '💻 Technology': [
    'Programming & Coding', 'AI & Machine Learning', 'Web Development',
    'App Development', 'Cybersecurity', 'Robotics', '3D Printing', 'VR & AR',
    'Blockchain & Crypto', 'Data Science', 'Game Development', 'Open Source',
    'Smart Home & Automation', 'Drones', 'Electronics & Arduino', 'UX Design'
  ],
  '🎮 Gaming': [
    'Video Games', 'Board Games', 'Card Games', 'Tabletop RPGs', 'Poker', 'Chess',
    'Puzzles & Escape Rooms', 'Trivia', 'Retro Gaming', 'Esports',
    'Game Streaming', 'Cosplay', 'LARPing', 'Warhammer & Miniatures'
  ],
  '🌿 Outdoors & Nature': [
    'Camping', 'Bushwalking', 'Bird Watching', 'Gardening', 'Stargazing & Astronomy',
    'Beach & Ocean', 'National Parks', 'Foraging', 'Conservation & Volunteering',
    'Wildlife Photography', 'Rock Pooling', 'Mountain Biking', 'Trail Running',
    'Four-Wheel Driving', 'Canoeing'
  ],
  '📚 Reading & Writing': [
    'Book Clubs', 'Fiction', 'Non-Fiction', 'Sci-Fi & Fantasy', 'True Crime',
    'Poetry', 'Journaling', 'Creative Writing', 'Blogging', 'Comics & Manga',
    'Audiobooks', 'Philosophy', 'History Books', 'Self-Help & Personal Development',
    'Screenwriting'
  ],
  '🎬 Film & TV': [
    'Movies', 'Documentaries', 'Anime', 'Horror', 'Sci-Fi', 'Comedy', 'Indie Film',
    'Film Festivals', 'Home Cinema', 'Movie Marathons', 'TV Series & Binging',
    'Film Photography', 'Movie Trivia', 'Stand-Up Comedy'
  ],
  '🎓 Learning & Education': [
    'Languages', 'History', 'Science', 'Psychology', 'Economics', 'Public Speaking',
    'Debating', 'Workshops', 'Online Courses', 'Mentoring', 'Teaching',
    'TED Talks', 'Lectures', 'Museums', 'Podcasts'
  ],
  '🤝 Social & Community': [
    'Volunteering', 'Charity Work', 'Activism', 'Politics',
    'Environmental Causes', 'Animal Welfare', 'Mentoring', 'Networking',
    'Community Organising', 'Cultural Events', 'Festivals', 'Markets', 'Meetups'
  ],
  '🧘 Wellbeing & Mindfulness': [
    'Meditation', 'Breathwork', 'Journaling', 'Mental Health Awareness',
    'Sound Healing', 'Retreats', 'Spa & Self-Care', 'Aromatherapy',
    'Acupuncture', 'Nutrition', 'Sleep Optimisation', 'Cold Water Therapy',
    'Mindful Walking'
  ],
  '✈️ Travel & Exploration': [
    'Road Trips', 'Backpacking', 'Solo Travel', 'Luxury Travel', 'Cultural Travel',
    'Van Life', 'Hostels', 'City Breaks', 'Adventure Travel', 'Island Hopping',
    'Train Travel', 'Travel Photography', 'Language Immersion', 'Festivals Abroad',
    'House Sitting'
  ],
  '💼 Business & Career': [
    'Entrepreneurship', 'Startups', 'Investing', 'Real Estate', 'Marketing',
    'Side Hustles', 'Freelancing', 'Leadership', 'Productivity',
    'Finance & Budgeting', 'Networking', 'Career Coaching', 'E-Commerce',
    'Content Creation'
  ],
  '🐾 Pets & Animals': [
    'Dogs', 'Cats', 'Aquariums & Fish', 'Birds', 'Reptiles', 'Horse Riding',
    'Pet Training', 'Animal Rescue', 'Wildlife', 'Veterinary Interest',
    'Pet Photography'
  ],
  '🏠 Family & Lifestyle': [
    'Parenting', 'Kids Activities', 'Home Decorating & Interior Design',
    'DIY & Home Improvement', 'Thrifting & Op Shopping', 'Sustainability & Zero Waste',
    'Minimalism', 'Vintage & Antiques', 'Fashion & Style', 'Sneakers',
    'Cars & Automotive', 'Motorcycles', 'Motorsport'
  ],
  '✨ Spiritual & Cultural': [
    'Religion & Faith', 'Astrology', 'Tarot', 'Indigenous Culture',
    'Cultural Heritage', 'Philosophy', 'Mythology', 'Ceremony & Ritual'
  ]
};

export default interestsData;
